import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import SvgIcon from 'components/SvgIcon/SvgIcon';
import { get, toTitleCase } from 'helpers/HelperFunctions';
import { connect } from 'react-redux';
import {
  addToLikedPitches,
  addToShortlistedPitches,
  loadLikedPitches,
  loadShortlistedPitches,
  likePitch,
  resetLoadedLikedPitches,
  resetLoadedPendingPitches,
  resetLoadedShortlistedPitches,
  loadPendingPitches,
  loadMorePendingPitches,
} from 'redux/modules/briefs2';
import { resetBriefDetails } from 'redux/modules/briefDetails';
import { setSuccessMessage } from 'redux/modules/successMessage';
import { denormalize } from 'normalizr';
import messageSchema from 'redux/schemas/messageSchema';
import Loader from 'components/Loader/Loader';
import Panel from 'components/Panel/Panel';
import { trackEvent } from 'helpers/Analytics';
import styles from './PitchBox.module.scss';
import BrowseCTA from 'components/Shared/Buttons/BrowseCTA/BrowseCTA';
import { setPinderTab } from 'redux/modules/briefs2';

import PinderLikedUserCardList from 'components/BriefDetailsClient/PitchBox/PinderLikedUserCardList';
import PinderNewTabList from 'components/BriefDetailsClient/PitchBox/PinderNewTabList';
import PinderHireUserCard from 'components/BriefDetailsClient/PitchBox/PinderHireUserCard';
import { DEFAULT_PENDING_PITCHES_TO_LOAD } from 'constants/constants';
import LazyLoadWrapper from 'components/LazyLoad/LazyLoad';
import { Link } from 'react-router-dom';

@connect(
  (
    {
      briefs2: briefs,
      entities: { messages: messageEntities, users: userEntities },
      briefCard: { activeHires },
    },
    props
  ) => {
    // Use encodedId if provided, otherwise fall back to params.id for backward compatibility
    const id = props.encodedId || (props.params && props.params.id);

    const {
      loadingLikedPitches,
      loadingPendingPitches,
      loadingMorePendingPitches,
      loadingShortlistedPitches,
      loadedLikedPitches,
      loadedPendingPitches,
      loadedShortlistedPitches,
      nextPageToLoad,
      likedPitches = [],
      pendingPitches = [],
      shortlistedPitches = [],
      totalPendingPitches,
    } = briefs[id];

    return {
      activeHires,
      loadingLikedPitches,
      loadingPendingPitches,
      loadingShortlistedPitches,
      loadedLikedPitches,
      loadedPendingPitches,
      loadedShortlistedPitches,
      messageEntities,
      likedPitches,
      pendingPitches,
      shortlistedPitches,
      userEntities,
      totalPendingPitches,
      loadingMorePendingPitches,
      nextPageToLoad,
    };
  },
  {
    addToLikedPitches,
    addToShortlistedPitches,
    loadLikedPitches,
    loadShortlistedPitches,
    loadPendingPitches,
    likePitch,
    resetLoadedLikedPitches,
    resetLoadedShortlistedPitches,
    resetLoadedPendingPitches,
    setSuccessMessage,
    setPinderTab,
    loadMorePendingPitches,
    resetBriefDetails,
  }
)
export default class PitchBox extends Component {
  static propTypes = {
    activeHires: PropTypes.array,
    brief: PropTypes.object,
    params: PropTypes.object,
    encodedId: PropTypes.string, // New SEO-friendly URL format support
    totalPendingPitches: PropTypes.number,
    pitches: PropTypes.array,
    pitchListProps: PropTypes.object,

    pendingPitches: PropTypes.array,
    loadPendingPitches: PropTypes.func,
    loadingPendingPitches: PropTypes.bool,
    loadedPendingPitches: PropTypes.bool,
    resetLoadedPendingPitches: PropTypes.func,

    likedPitches: PropTypes.array,
    addToLikedPitches: PropTypes.func,
    loadLikedPitches: PropTypes.func,
    loadingLikedPitches: PropTypes.bool,
    loadedLikedPitches: PropTypes.bool,
    resetLoadedLikedPitches: PropTypes.func,
    likePitch: PropTypes.func,

    shortlistedPitches: PropTypes.array,
    addToShortlistedPitches: PropTypes.func,
    loadShortlistedPitches: PropTypes.func,
    loadingShortlistedPitches: PropTypes.bool,
    loadedShortlistedPitches: PropTypes.bool,
    resetLoadedShortlistedPitches: PropTypes.func,

    onAccepted: PropTypes.func,
    onDeclined: PropTypes.func,
    setSuccessMessage: PropTypes.func,
    setPinderTab: PropTypes.func,

    messageEntities: PropTypes.object,
    userEntities: PropTypes.object,

    loadingMorePendingPitches: PropTypes.bool,
    nextPageToLoad: PropTypes.number,
    loadMorePendingPitches: PropTypes.func,
    resetBriefDetails: PropTypes.func,
  };

  static defaultProps = {
    loadingShortlistedPitches: false,
    loadedShortlistedPitches: false,
    shortlistedPitches: [],

    pendingPitches: [],
    loadingPendingPitches: false,
    loadedPendingPitches: false,

    likedPitches: [],
    loadingLikedPitches: false,
    loadedLikedPitches: false,
  };

  constructor(props) {
    super(props);

    this.state = {
      cardAnimation: false,
      selected: props.params.subsection || 'new',
      pitches: {
        new: this.getPendingEntities(),
        shortlisted: this.getShortlistedEntities(),
        liked: this.getLikedEntities(),
        hired: [],
        page: 1,
      },
      buttonStyleRelative: false,
    };
    this.navRef = createRef();
    this.userCardRef = createRef();
  }

  componentDidMount() {
    this._loadPendingPitches();
    this._loadShortlistedPitches();
    this._loadLikedPitches();
  }

  componentDidUpdate(
    {
      likedPitches: prevLiked,
      pendingPitches: prevPending,
      shortlistedPitches: prevShortlisted,
    },
    { selected: prevSelected }
  ) {
    const { selected } = this.state;
    if (prevSelected !== selected) {
      // Get the ID from encodedId prop or fall back to params.id for backward compatibility
      const id =
        this.props.encodedId || (this.props.params && this.props.params.id);

      if (selected === 'shortlisted') {
        this._loadShortlistedPitches();
        this.props.setPinderTab(id, false);
      }
      if (selected === 'liked') {
        this._loadLikedPitches();
        this.props.setPinderTab(id, false);
      }
      if (selected === 'new') {
        this._loadPendingPitches();
        this.props.setPinderTab(id, true);
      }
    }

    if (prevShortlisted.length !== this.props.shortlistedPitches.length) {
      this.setShortlisted();
    }
    if (prevLiked.length !== this.props.likedPitches.length) {
      this.setLiked();
    }
    if (prevPending.length !== this.props.pendingPitches.length) {
      this.setPending();
    }
  }

  componentWillUnmount() {
    const {
      params,
      encodedId: propEncodedId,
      resetLoadedShortlistedPitches,
      resetLoadedLikedPitches,
      resetLoadedPendingPitches,
      setPinderTab,
      resetBriefDetails,
    } = this.props;

    // Get the ID from encodedId prop or fall back to params.id for backward compatibility
    const id = propEncodedId || (params && params.id);

    resetLoadedShortlistedPitches(id);
    resetLoadedLikedPitches(id);
    resetLoadedPendingPitches(id);
    setPinderTab(id, false);
    resetBriefDetails();
  }

  static getPitchSectionCount = (count) => (count > 0 ? ` (${count})` : '');

  getPitchEntities = (type) => {
    const {
      messageEntities: messages,
      userEntities: users,
      [`${type}Pitches`]: pitches,
    } = this.props;

    return denormalize(pitches, [messageSchema], {
      messages,
      users,
    }).filter(Boolean);
  };

  getListItems = () => ({
    new: {
      title: 'new',
      icon: 'book',
      count: this.props.totalPendingPitches,
    },
    liked: {
      title: 'Shortlist',
      icon: 'plus',
      count: this.props.likedPitches.length,
    },
    hired: {
      title: 'hired',
      icon: 'tick',
      count: this.props.activeHires.length,
    },
  });

  getLikedEntities = () => this.getPitchEntities('liked');

  getShortlistedEntities = () => this.getPitchEntities('shortlisted');

  getPendingEntities = () => this.getPitchEntities('pending');

  getTabStyle = (title) =>
    this.state.selected === title ? `${styles.active}` : '';

  setActive = (title) => {
    this.scrollToNav();
    return this.setState({ selected: title });
  };

  getPitchSection = (name) => get(this.state, ['pitches', name], []);

  getCurrentPitchSection = () => this.getPitchSection(this.state.selected);

  setShortlisted = () =>
    this.setState((state) => {
      state.pitches.shortlisted = this.getShortlistedEntities();
      return state;
    });

  setLiked = () =>
    this.setState((state) => {
      state.pitches.liked = this.getLikedEntities();
      return state;
    });

  setPending = () =>
    this.setState((state) => {
      state.pitches.new = this.getPendingEntities();
      return state;
    });

  _loadShortlistedPitches = () => {
    const {
      brief,
      loadShortlistedPitches,
      loadingShortlistedPitches,
      loadedShortlistedPitches,
      params,
      encodedId: propEncodedId,
    } = this.props;

    // Get the ID from encodedId prop or fall back to params.id for backward compatibility
    const id = propEncodedId || (params && params.id);

    const { selected } = this.state;

    if (
      (selected === 'shortlisted' ||
        (params && params.subsection === 'shortlisted')) &&
      !loadingShortlistedPitches &&
      !loadedShortlistedPitches
    ) {
      return loadShortlistedPitches(id, brief);
    }
  };

  _loadLikedPitches = () => {
    const {
      brief,
      loadLikedPitches,
      loadingLikedPitches,
      loadedLikedPitches,
      params,
      encodedId: propEncodedId,
    } = this.props;

    // Get the ID from encodedId prop or fall back to params.id for backward compatibility
    const id = propEncodedId || (params && params.id);

    const { selected } = this.state;

    if (
      (selected === 'liked' || (params && params.subsection === 'liked')) &&
      !loadingLikedPitches &&
      !loadedLikedPitches
    ) {
      return loadLikedPitches(id, brief);
    }
  };

  _loadPendingPitches = (
    page = 1,
    numberOfPitches = DEFAULT_PENDING_PITCHES_TO_LOAD
  ) => {
    const {
      brief,
      loadPendingPitches,
      loadingPendingPitches,
      loadedPendingPitches,
      params,
      encodedId: propEncodedId,
    } = this.props;

    // Get the ID from encodedId prop or fall back to params.id for backward compatibility
    const id = propEncodedId || (params && params.id);

    const { selected } = this.state;

    if (
      (selected === 'new' || (params && params.subsection === 'new')) &&
      !loadingPendingPitches &&
      !loadedPendingPitches
    ) {
      return loadPendingPitches(id, brief, page, numberOfPitches);
    }
  };

  loadMorePitches = (numberOfPitches = DEFAULT_PENDING_PITCHES_TO_LOAD) => {
    const {
      brief,
      loadMorePendingPitches,
      loadingMorePendingPitches,
      params,
      encodedId: propEncodedId,
      totalPendingPitches,
      nextPageToLoad,
    } = this.props;

    // Get the ID from encodedId prop or fall back to params.id for backward compatibility
    const id = propEncodedId || (params && params.id);

    if (
      !loadingMorePendingPitches &&
      totalPendingPitches !== 0 &&
      this.getPendingEntities().length < totalPendingPitches
    ) {
      return loadMorePendingPitches(id, brief, nextPageToLoad, numberOfPitches);
    }
  };

  setButtonStyle = (isVisible) => {
    this.setState({ buttonStyleRelative: isVisible });
  };

  animateCard = (cb) =>
    this.setState({ cardAnimation: 'exit' }, () => {
      setTimeout(cb, 500);

      setTimeout(
        () =>
          this.setState({ cardAnimation: 'entry' }, () =>
            setTimeout(() => this.setState({ cardAnimation: null }), 500)
          ),
        500
      );
    });

  scrollToNav = () => {
    this.navRef && this.navRef.current.scrollIntoView({ behavior: 'smooth' });
    setTimeout(() => {
      this.setState({ buttonStyleRelative: false });
    }, 500);
  };

  handleLike = (pitchID) => {
    trackEvent('user-likes-freelancer');

    // Get the ID from encodedId prop or fall back to params.id for backward compatibility
    const id =
      this.props.encodedId || (this.props.params && this.props.params.id);

    this.props
      .likePitch(id, this.props.brief, pitchID)
      .then(() => this.props.addToLikedPitches(id, pitchID));
  };

  handleDislike = (pitch) => {
    trackEvent('user-dislikes-freelancer');
    this.props.onDeclined(pitch);
  };

  isLoading = () => {
    const { selected } = this.state;

    return (
      (selected === 'new' &&
        (this.props.loadingPendingPitches ||
          !this.props.loadedPendingPitches)) ||
      (selected === 'liked' && this.props.loadingLikedPitches) ||
      (selected === 'shortlisted' && this.props.loadingShortlistedPitches)
    );
  };

  emptyMessage = (title) => {
    if (title === 'liked') {
      title = 'shortlisted';
    }
    return (
      <div
        className={`f f-col jc-center ac-center`}
        style={{ marginTop: '5px' }}
      >
        <LazyLoadWrapper>
          <iframe
            width="560"
            height="315"
            src="https://www.youtube.com/embed/fEFFCCCp7wI"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </LazyLoadWrapper>

        <h3 style={{ marginBottom: '20px', color: 'grey' }}>{`${
          title === 'hired'
            ? 'Active hires'
            : `${toTitleCase(title)} applicants`
        } will be listed here`}</h3>
        <BrowseCTA browseFilter={this.props.brief} />
        <Panel
          className="box-shadow"
          style={{ padding: '30px 20px', marginTop: '40px' }}
        >
          <p>
            <b>Would you like to BOOST your job?</b>
          </p>
          <p>
            <ul>
              <li>Job placed at the top of search results.</li>
              <li>
                Get up to <b>10x more</b> top tier applicants!
              </li>
            </ul>
          </p>
          <p>
            <i>Rocket Boost</i> jobs get shared to up to 17 jobs boards such as
            LinkedIn and Indeed automatically.
          </p>
          <p>
            🚀{' '}
            <a
              href="https://buy.stripe.com/7sI15JdwseK73n23cj"
              target="_blank"
              rel="noreferrer"
            >
              Upgrade to Rocket Boost
            </a>{' '}
            - $199.99 for 30 days
          </p>
          <p>
            ✈️{' '}
            <a
              href="https://buy.stripe.com/28o8ybbokbxV7DiaEM"
              target="_blank"
              rel="noreferrer"
            >
              Upgrade to Jet Boost
            </a>{' '}
            - $49.99 for 7 days
          </p>
          <p>
            <b>Business need more help?</b> Want a personalized shortlist
            straight to your inbox?{' '}
            <Link to={'/enterprise'} target="_blank">
              Upgrade to Twine Business or Enterprise
            </Link>
            .
          </p>
        </Panel>
      </div>
    );
  };

  isEmpty = () => {
    const { selected } = this.state;
    return (
      (selected === 'new' && this.getListItems().new.count === 0) ||
      (selected === 'liked' && this.getListItems().liked.count === 0) ||
      (selected === 'shortlisted' &&
        this.getListItems().shortlisted.count === 0) ||
      (selected === 'hired' && this.getListItems().hired.count === 0)
    );
  };

  render() {
    const newPitchList = this.getPitchSection('new');
    const { cardAnimation, selected } = this.state;
    const { activeHires, pitchListProps, brief } = this.props;
    const listItems = this.getListItems();

    return (
      <div className={styles.container}>
        <div className={styles.tabs}>
          <ul
            style={{ margin: 0, padding: 0 }}
            id="pitch-tab-navigation"
            ref={this.navRef}
          >
            {Object.keys(listItems).map((key) => {
              const { title, icon, count } = listItems[key];
              return (
                <li
                  className={this.getTabStyle(key)}
                  key={`pitchbox-pitch-nav-${title}`}
                  onClick={() => this.setActive(key)}
                >
                  <SvgIcon
                    icon={icon}
                    size="16"
                    key={`pitchbox-pitch-svgicon-${title}`}
                  />{' '}
                  {`${toTitleCase(title)}${PitchBox.getPitchSectionCount(
                    count
                  )}`}
                </li>
              );
            })}
          </ul>
        </div>
        <div
          className={[
            styles.card,
            selected === 'new'
              ? cardAnimation === 'exit'
                ? styles.cardExit
                : cardAnimation === 'entry'
                ? styles.cardEntry
                : ''
              : '',
          ].join(' ')}
        >
          {this.isLoading() ? (
            <Loader loading />
          ) : this.isEmpty() ? (
            this.emptyMessage(selected)
          ) : selected === 'new' ? (
            <PinderNewTabList
              loadMore={this.loadMorePitches}
              pitches={newPitchList}
              brief={brief}
              pitchListProps={pitchListProps}
              handleLike={this.handleLike}
              handleDislike={this.handleDislike}
              isLoadingMore={this.props.loadingMorePendingPitches}
              userCardRef={this.userCardRef}
            />
          ) : selected === 'hired' ? (
            activeHires.map((activeHire) => (
              <PinderHireUserCard
                activeHire={activeHire}
                key={'pitchbox-activehire-pitch' + activeHire.id}
                endHireUpdateActiveHires={() => {}}
              />
            ))
          ) : (
            // Liked and shortlisted tabs
            <PinderLikedUserCardList
              pitchListProps={pitchListProps}
              pitches={this.getCurrentPitchSection()}
              preferredRole={brief?.role}
              userCardRef={this.userCardRef}
            />
          )}
        </div>
      </div>
    );
  }
}
